import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(onChange: () => void) {
  const mql = window.matchMedia?.(QUERY);
  mql?.addEventListener?.("change", onChange);
  return () => mql?.removeEventListener?.("change", onChange);
}

/**
 * Whether the visitor asked the OS for less motion.
 *
 * Use this instead of framer-motion's `useReducedMotion` in anything a
 * prerendered page renders. framer reads the setting during the very first
 * render in the browser, so for those visitors the page's first render differs
 * from the prerendered HTML and React discards the HTML and renders again.
 * Here the first render always says "no preference", like the prerender did,
 * and the real value follows straight after hydration.
 */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia?.(QUERY).matches ?? false,
    () => false,
  );
}
